import { render, staticRenderFns } from "./RelationDetail.vue?vue&type=template&id=c766dd5a&scoped=true"
import script from "./RelationDetail.vue?vue&type=script&lang=js"
export * from "./RelationDetail.vue?vue&type=script&lang=js"
import style0 from "./RelationDetail.vue?vue&type=style&index=0&id=c766dd5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c766dd5a",
  null
  
)

export default component.exports